import React, { useState } from 'react';
import { HelpCircle, Info } from 'lucide-react';

interface HelpTooltipProps {
    title: string;
    description: string;
    benefit?: string;
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ title, description, benefit }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div
            className="relative inline-flex items-center ml-2 group"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            <HelpCircle
                size={16}
                className="text-gray-400 hover:text-blue-500 cursor-help transition-colors"
            />

            {isVisible && (
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-xl z-50">
                    <div className="font-bold mb-1 text-blue-300">{title}</div>
                    <div className="mb-2 text-gray-200">{description}</div>
                    {benefit && (
                        <div className="flex items-start gap-1 p-1.5 bg-gray-800 rounded">
                            <Info size={12} className="mt-0.5 text-green-400 shrink-0" />
                            <span className="text-gray-300 italic">{benefit}</span>
                        </div>
                    )}
                    {/* Triangle Pointer */}
                    <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-gray-900"></div>
                </div>
            )}
        </div>
    );
};

export default HelpTooltip;
